import { BaseFormComponent } from "../../../../shared/components/base-form/base-form.component";
import { Component, OnInit } from "@angular/core";
import { FiltroModel } from "../../../../models/filtro.model";
import { AuthService } from "../../../../services/auth.service";
import { EntendendoEntidadeService } from "../../../../services/entendendo-entidade.service";
import { QuestionarioUGRespostaService } from "../../../../services/questionarioug-resposta.service";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { SharedService } from "../../../../services/shared.service";
import { ToastrService } from "ngx-toastr";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { TipoUniversoService } from "../../../../services/tipo-universo.service";
import { UniversoAuditavelService } from "../../../../services/universo-auditavel.service";
import { IArquivoModel } from "../../../../models/arquivo.model";
import Swal from "sweetalert2";
import { RiscosChavesServices } from "../../../../services/riscos-chaves.service";


@Component({
  selector: 'app-importar-arquivo-risco-chaves',
  templateUrl: './importar-arquivo-risco-chaves.component.html',
  styleUrls: ['./importar-arquivo-risco-chaves.component.scss']
})
export class ImportarArquivoRiscosChavesComponent extends BaseFormComponent implements OnInit {
  public filtro = {} as FiltroModel;

  universoId: number;
  tipoUniversoId: number;
  unidadeGestoraId: number;
  criterioAvaliacaoId: number;
  searchTerm: string = '';
  nomeTipoUniverso: string = '';
  arquivo: File | null = null;
  arquivoUrl: string;
  nomeArquivo: string;
  errorMessage: string | null = null;
  botaoEncerrarHabilitado: boolean = true;
  maxFileSizeMB: number = 28;
  constructor(
    private authService: AuthService,
    private tipoUniversoService: TipoUniversoService,
    private universoAuditavelService: UniversoAuditavelService,
    private riscoService: RiscosChavesServices,
    matDialog: MatDialog,
    router: Router,
    private sharedService: SharedService,
    route: ActivatedRoute,
    toastr: ToastrService,
    localeService: BsLocaleService
  ) {
    super(route, toastr, router, localeService, matDialog);
  }

  ngOnInit(): void {

    this.unidadeGestoraId = this.route.snapshot.queryParams['unidadeGestoraId'];
    this.universoId = this.route.snapshot.queryParams['tipoUniversoId'];
    this.criterioAvaliacaoId = this.route.snapshot.queryParams['criterioAvaliacaoId'];

    this.buscarTipoUniverso();
    this.downloadAnexo();
  }

  public buscarTipoUniverso() {

    if (this.universoId !== null) {
      this.universoAuditavelService.obterPorId(this.universoId).then(res => {
        if (res.sucesso) {
          this.nomeTipoUniverso = res.dados.nomeTipoUniversoAuditavel;
          this.tipoUniversoId = res.dados.tipoUniversoAuditavelId;
        } else {
          this.exibirMensagemAlerta('Tipo não encontrado!');
        }
      })
    }
  }


  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    const maxBytes = this.maxFileSizeMB * 1024 * 1024;
    if (file) {
      // Verifica se a extensão do arquivo é PDF
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      if (fileExtension !== 'pdf') {
        // Emite um aviso caso a extensão não seja PDF
        this.errorMessage = 'Por favor, selecione um arquivo PDF!';
        this.arquivo = null; // Reseta o arquivo selecionado
      } else if (file.size > maxBytes) {
        this.toastr.error("O arquivo excede o tamanho máximo de " + this.maxFileSizeMB + "MB.");
        this.arquivo = null; // Reseta o arquivo selecionado
      }
      else {
        this.arquivo = file;
        this.errorMessage = null;
      }
    }
  }
  public onBack() {
    this.submit = false;
    this.router.navigateByUrl(`/unidades-gestoras/${this.unidadeGestoraId}?aba=4`);
  }

  enviarArquivo(): void {

    if (this.arquivo) {
      const arquivoModel: IArquivoModel = {
        id: 0,
        nomeArquivo: this.arquivo.name,
        entidadeArquivo: 1,
        arquivo: this.arquivo,
        url: ''
      };



      this.riscoService.enviarArquivo(this.unidadeGestoraId, this.universoId, this.criterioAvaliacaoId, arquivoModel).then(
        (response) => {
          this.downloadAnexo();
          this.exibirMensagemSucesso('Arquivo importado com sucesso');
          // this.router.navigateByUrl(`/unidades-gestoras/${this.unidadeGestoraId}?aba=1`);
        },
        (error) => {
          this.exibirMensagemErro(error.mensagem.descricao);
        }
      );
    }
  }

  search(): void {
    console.log('Searching for:', this.searchTerm);
    // Implementar lógica de pesquisa aqui
  }

  finalizarAvaliacao(): void {
    console.log('Avaliação finalizada');
    // Implementar lógica de finalização aqui
  }

  cancelar(): void {
    console.log('Operação cancelada');
    // Implementar lógica de cancelamento aqui
  }


  onEncerrarAvaliacao() {
    Swal.fire({
      title: 'Atenção',
      text: "Esta ação não poderá ser desfeita! Deseja continuar? ",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
    }).then((res) => {
      if (res.value) {
        this.riscoService.encerrarRiscoImportacaoArquivo(this.unidadeGestoraId, this.tipoUniversoId)
          .then((res) => {
            if (res.sucesso) {
              this.router.navigateByUrl(`/unidades-gestoras/${this.unidadeGestoraId}?aba=4`);
            }
            else {
              this.exibirMensagemErro(res.mensagem.descricao);
            }
          })

      }
    })
  }

  downloadAnexo(): void {
    this.riscoService.DownloadArquivo(this.unidadeGestoraId, this.tipoUniversoId).then(res => {
      if (res.sucesso && res.dados !== undefined) {
        this.arquivoUrl = res.dados.url;
        this.nomeArquivo = res.dados.nomeArquivo;
        if (res.dados.id) {
          this.botaoEncerrarHabilitado = false;  // Habilita o botão
        }
      } else {
        return;
      }
    });
  }
}
